import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Handle, Position } from '@xyflow/react';
import MoleculeNodeContent from './moleculeNodeContent.js';
import MoleculeInfo from '../ResultsTable/MoleculeInfo.js';
 
 /// data: srcImg, name, marts, 
function MoleculeNodeLR({ data }) {
  const onChange = useCallback((evt) => {
    console.log(evt.target.value);
  }, []);
 
  return (
    <div
      className="molecule-node"
      style={data.highlight ? { backgroundColor: data.highlight } : {}}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={false}
      />
     <MoleculeNodeContent data={data} />
      <Handle
        type="source"
        position={Position.Right}
        id="b"
        isConnectable={false}
      />
    </div>
  );
}
 
export default MoleculeNodeLR;